"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { cookingLoadingService } from "_services/loadingCooking.service";

export function NavigationLoader() {
  const pathname = usePathname();

  useEffect(() => {
    // Hide loading when pathname changes
    cookingLoadingService.loading(false);
  }, [pathname]);

  return null;
}

export default NavigationLoader;
